module.exports = __webpack_public_path__ + "img/aroma-benefit-report.481a0988.svg";